module.exports = __webpack_public_path__ + "static/media/icon-facebook.84f9348f.svg";